"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SignInWithEpicButton = require("./SignInWithEpicButton");

var _SignInWithEpicButton2 = _interopRequireDefault(_SignInWithEpicButton);

var _EpicSubscriptionLogin = require("./EpicSubscriptionLogin.scss");

var _EpicSubscriptionLogin2 = _interopRequireDefault(_EpicSubscriptionLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EpicSubscriptionLogin = function (_React$Component) {
  (0, _inherits3.default)(EpicSubscriptionLogin, _React$Component);

  function EpicSubscriptionLogin() {
    (0, _classCallCheck3.default)(this, EpicSubscriptionLogin);
    return (0, _possibleConstructorReturn3.default)(this, (EpicSubscriptionLogin.__proto__ || (0, _getPrototypeOf2.default)(EpicSubscriptionLogin)).apply(this, arguments));
  }

  (0, _createClass3.default)(EpicSubscriptionLogin, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: _EpicSubscriptionLogin2.default.wrap },
        _react2.default.createElement(
          "h1",
          { className: _EpicSubscriptionLogin2.default.heading },
          "Quixel is part of the Epic Games family"
        ),
        _react2.default.createElement(
          "p",
          null,
          "Since you have the Epic Games Content License, we can set you up with unlimited access to Megascans. Unlimited Megascans access is licensed for use with Unreal Engine based products only."
        ),
        _react2.default.createElement(_SignInWithEpicButton2.default, null)
      );
    }
  }]);
  return EpicSubscriptionLogin;
}(_react2.default.Component);

exports.default = EpicSubscriptionLogin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicSubscriptionLogin.jsx
// module id = 1259
// module chunks = 0